module.exports = __webpack_public_path__ + "static/media/Bsintroimage.91ac68a3.png";